import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Content } from '../../models';
import { ContentService } from './../../services/content.service';

@Component({
  selector: 'content-card-small',
  styleUrls: ['./content.css'],
  templateUrl: './content-card-small.component.html',
})
export class ContentCardSmallComponent implements OnInit {
  @Input() public content: Content;

  public bgColor: string;

  constructor(private _contentService: ContentService) { }

  public ngOnInit() { }

  public getAverageColor() {
    if (!this.content.thumbnailPath.includes('no-image')) {
      const img = document.getElementById('contentImage-' + this.content._id);
      if (img) { this.bgColor = this.calcAverage(img) }
    }
  }

  public calcAverage(img) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const width = (canvas.width = img.naturalWidth);
    const height = (canvas.height = img.naturalHeight);
    ctx.drawImage(img, 0, 0);

    const imageData = ctx.getImageData(0, 0, width, height);
    const data = imageData.data;
    let r = 0;
    let g = 0;
    let b = 0;

    for (let i = 0, l = data.length; i < l; i += 4) {
      r += data[i];
      g += data[i + 1];
      b += data[i + 2];
    }

    r = Math.floor(r / (data.length / 4));
    g = Math.floor(g / (data.length / 4));
    b = Math.floor(b / (data.length / 4));

    return this.rgbToHex(r, g, b);
  }

  public componentToHex(c) {
    const hex = c.toString(16);
    return hex.length == 1 ? '0' + hex : hex;
  }

  public rgbToHex(r, g, b) {
    return (
      '#' +
      this.componentToHex(r) +
      this.componentToHex(g) +
      this.componentToHex(b)
    );
  }
}
